export type Category = 'title' | 'artist' | 'decade' | 'before2000' | 'year4';

export const CATEGORIES: readonly Category[] = ['title', 'artist', 'decade', 'before2000', 'year4'];

export const CATEGORY_META: Record<Category, { label: string; short: string; color: string }> = {
  title: { label: 'Song Title', short: 'TTL', color: '#ff3df2' },
  artist: { label: 'Name the Artist', short: 'ART', color: '#7df9ff' },
  decade: { label: 'Decade', short: 'DEC', color: '#ffd43b' },
  before2000: { label: 'Before or after?', short: '<2K', color: '#69db7c' },
  year4: { label: '4 Years Up or Down', short: '±4', color: '#9775fa' },
};

export type Decade = 1960 | 1970 | 1980 | 1990 | 2000 | 2010 | 2020;

export const DECADES: readonly Decade[] = [1960, 1970, 1980, 1990, 2000, 2010, 2020];

export function decadeOf(year: number): Decade {
  if (!Number.isFinite(year) || year < 1960 || year > 2029) {
    throw new RangeError(`Year ${year} is outside 1960-2029`);
  }
  return (Math.floor(year / 10) * 10) as Decade;
}

export type Cutoff = 2000 | 2010;

/**
 * The Before/After cutoff for a set of decades: 2000 when they straddle 2000,
 * 2010 when only 2000s-and-later are on and straddle 2010, otherwise null (category off).
 */
export function cutoffYear(decades: readonly number[]): Cutoff | null {
  if (decades.some((d) => d < 2000) && decades.some((d) => d >= 2000)) return 2000;
  if (decades.every((d) => d >= 2000) && decades.some((d) => d === 2000) && decades.some((d) => d >= 2010)) return 2010;
  return null;
}

/** Category label with the live cutoff filled in ("Before 2010?"). */
export function categoryLabel(category: Category, cutoff: number | null | undefined): string {
  return category === 'before2000' ? `Before ${cutoff ?? 2000}?` : CATEGORY_META[category].label;
}

/** Card-square short label; `<10` when the cutoff is 2010, `<2K` otherwise. */
export function categoryShort(category: Category, cutoff: number | null | undefined): string {
  return category === 'before2000' && cutoff === 2010 ? '<10' : CATEGORY_META[category].short;
}
